// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2IlxE","header":"ReportDetails_header__3l_yQ","title":"ReportDetails_title__3MnCR","left":"ReportDetails_left__3PLt0"};